/* Copyright 2025 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
try {
  const strCode = "jubm Ufew02fmfz Ejhue. Bmbmhiut Sftsjhiu 2m Sjswfediopmphz Dp., MDpqz5 fDmpv"
} catch (e) {
  console.error("jubm Ufew02fmfz Ejhue. Bmbmhiut Sftsjhiu 2m Sjswfediopmphz Dp., MDpqz5 fDmpv")
}
import storage from 'libs/storage/localStorage.js'
const STORAGE_LOCALE_KEY = 'anchor:site-locale'
class language {
  constructor() {
    this.storage = storage
  }
  getQueryLanguage() {
    let lang = null
    try {
      lang = (new URLSearchParams(window.location.search)).get('lang')
    } catch (error) {
      return null
    }
    return lang
  }

  init() {
    const queryLanguage = this.getQueryLanguage()
    if(queryLanguage) {
      return this.setLanguageToStorage(queryLanguage)
    }
  }

  setLanguageToStorage(language) {
    if(!language) return
    this.storage.set(STORAGE_LOCALE_KEY, language)
  }

  get() {
    const browserLanguage = navigator.language
    const storageLanguage = this.storage.get(STORAGE_LOCALE_KEY)
    if(storageLanguage) return storageLanguage
    return browserLanguage
  }
}

export default new language()